<template>
    <div class="location-back">
        <!--环图片-->
        <div class="img-box">
            <div class="prop-up"></div>
            <img src="@/assets/img/circle.png" class="circle" alt="">
        </div>
        <!--题目-->
        <div class="subject">
            <div>你现在能看到或听到交通相关的东西吗？（例如马路、车辆、人行道、站牌、路灯、栏杆，或车流声）</div>
        </div>
        <!--选项-->
        <div style="width:70px;margin:calc(0.073 * var(--body-height)) auto 0;">
            <el-radio-group v-model="street">
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
                <el-radio label="不确定"></el-radio>
            </el-radio-group>
        </div>
        <!--题目跳转-->
        <div class="subject-jump">
            <span @click="prevClick" class="prev-btn">{{ $t('preQues') }}</span>
            <el-button @click="nextClick" :disabled="countNumber != 0" style="width:160px;"
                type="primary">{{ $t('nextQues') }} <i class="icon-right"></i> ({{ countNumber }}s)
            </el-button>
        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "street",
    data() {
        return {
            street: '',
            timer: null,
            countNumber: 0
        }
    },
    computed: {
        ...mapGetters([
            'streetAnswer',
            'codeItem'
        ]),
    },
    watch: {
        '$route': {
            immediate: true, // 组件创建时立即触发
            handler(newVal, oldVal) {
                this.$store.commit('SET_ANSWER_PERCENT', 19 * 100 / 22)
            }
        }
    },
    mounted() {
        this.countdown()
        this.street = this.streetAnswer
    },
    methods: {

        /**
         * 上一题
         */
        prevClick() {
            this.$router.push('/shop')
        },

        /**
         * 下一题
         */
        nextClick() {
            if (this.street == '') {
                this.$toast(this.$t('selectOne'));
                return;
            }
            //保存答案
            this.$store.commit('SET_STREET_ANSWER', this.street)
            this.codeItem[7][1] = this.street
           
            this.$router.push('/photo')
         
        },

        /**
         * 验证码倒计时
         */
        countdown() {
            let that = this;
            this.countNumber = 2;
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(function () {
                if (that.countNumber === 0) {
                    clearInterval(this.timer);
                } else {
                    that.countNumber--;
                }
            }, 1000);
        }
    }
}
</script>

<style scoped lang="less">
.location-back {
    height: 100%;
}
</style>
